module.exports = __webpack_public_path__ + "static/media/human_body.5dffd45e.jpg";